export const mdash = <>&mdash;</>;
export const mdashUnicode = "\u2014";
export const checkUnicode = "\u2713";
export const xUnicode = "\u2717";
